import * as React from 'react';
import { Button } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';

const RxGlassesCTA = ({ action , bookAppointmentRoute , onClickWhenOrderable , buttonRef , className , handleConversionEvent ,  })=>{
    const { getLabel  } = useIntl();
    return action === 'OPEN_CONFIGURATOR' ? // Open Configurator button
    /*#__PURE__*/ React.createElement(Button, {
        caption: getLabel('products.actions.openConfigurator'),
        "data-t": "btn-open-configurator",
        onClick: onClickWhenOrderable,
        btnRef: buttonRef,
        className: className
    }) : // Book Appointment button
    /*#__PURE__*/ React.createElement(Button, {
        caption: getLabel('products.actions.bookAppointment'),
        "data-t": "btn-book-examination",
        href: bookAppointmentRoute,
        className: className,
        onClick: handleConversionEvent
    });
};

export { RxGlassesCTA };
//# sourceMappingURL=RxGlassesCTA.js.map
